import { Login, Dashboard, NotFound } from '../scenes';

export const routes = [
  {
    path: '/',
    component: Login,
  },
  {
    path: '/dashboard',
    component: Dashboard,
  },
  {
    path: '*',
    component: NotFound,
  },
];
